import React from 'react';
import './SteakHouseSpecials.css';
import { Row } from 'react-bootstrap';
import Special from '../Special/Special';

const SteakHouseSpecials = ({ specials }) => {
    return (
        <div id="specials" className="my-0 my-lg-5" data-aos="fade-up">
            <h1 className="headline fw-bold">Steakhouse <span className="text-warning">Specials</span></h1>
            <Row xs={1} md={2} xl={3} className="gy-4 gx-0 gx-md-4 mt-0 mt-lg-4 specials  mx-auto">
                {
                    specials.map(special => <Special
                        key={special._id}
                        special={special}
                    />)
                }
            </Row>
        </div>
    );
};

export default SteakHouseSpecials;